import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/tickets/ticket', { params }),
  getById: (id) => axios.get(`/api/v1/tickets/ticket/${id}`),
  getCountByStatus: () => axios.get('/api/v1/tickets/ticket-count'),
  create: (params) => axios.post('/api/v1/tickets/ticket', params),
  update: (params, id) => axios.put(`/api/v1/tickets/ticket/${id}`, params),
  delete: (params) => axios.delete('/api/v1/tickets/ticket', { params }),
};
